module.exports = __webpack_public_path__ + "static/media/fallbackUserPicture.4ab43824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fallbackUserPicture.png
// module id = 123
// module chunks = 0